export default "__VITE_ASSET__BHRK4RM4__"